import { render, staticRenderFns } from "./list-modules.vue?vue&type=template&id=9fe5df0c"
import script from "./list-modules.vue?vue&type=script&lang=ts"
export * from "./list-modules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports